/**
 * @license
 * @copyright Copyright Motili Inc., 2018 All Rights Reserved
 */

module.exports = {
    path: '/m/order/return/:token',
    getComponent(nextState, callback) {
        require.ensure([], (require) => {
            callback(null, require('./ReturnContainer'));
        });
    }
};



// WEBPACK FOOTER //
// ./src/app/components/order/order-return/route.OrderReturn.js